import React from "react";
import "../css/about.scss";

function About() {
  return (
    <div className="about">
      <div className="about-content">
        <h1>about</h1>

        <div className="about-text">
          <p>
            tunrisefield creates unique notebooks with a focus on premium paper
            and high quality bindings. all of our notebooks feature fountain pen
            friendly paper sourced from the world's best paper mills.
          </p>

          <p>
            as fountain pen users we know how hard it can be to find the right
            paper products to get the absolute best out of our pens. we know
            that things like bleeding and feathering can get in the way of
            journaling, note taking, and drawing.
          </p>

          <p>
            we started tunrisefield with the goal of being a reliable
            source for fountain pen friendly paper products.
          </p>

          <p>
            our online store serves writing enthusiasts with practical
            stationery selected for everyday use.
          </p>

          <p>we put paper first.</p>

          <p>
            we test our paper thoroughly with different inks and nibs to make
            sure that it meets our high standard. we work with the best
            bookbinders to produce the highest quality products.
          </p>
        </div>
      </div>

      <div className="about-image-section">
        <img src="/main/a1.png" alt="Writing in a handmade notebook" />
        <div className="about-image-text">
          improve memory and creativity with handwriting
        </div>
      </div>
    </div>
  );
}

export default About;
